import { RiTeamLine } from "react-icons/ri";
import { FaRupeeSign } from "react-icons/fa";
import { AiOutlineBank } from "react-icons/ai";
import {
  MdCampaign,
} from "react-icons/md";
import { FcList } from "react-icons/fc";
import {
  FiSettings,
  FiUser,
  FiClock,
  FiDollarSign,
  FiBarChart,
  FiBell,
} from "react-icons/fi";
import { BiSupport } from "react-icons/bi";

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }
import {
  PieChartOutlined,
  TeamOutlined,
  ProjectOutlined,
  LogoutOutlined,
  LinkOutlined,
  CloudServerOutlined,
  MailOutlined,
  MessageOutlined,
} from "@ant-design/icons";

import { Badge, Drawer, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "store/slices/AuthSlice";
import useIsMobile from "hooks/useIsMobile";
import { useUnreadSummary } from "realtime/unreadSummary";

// Menu label with the unread-conversation count from the Communication inbox.
const UnreadLabel = ({ text }) => {
  const { total } = useUnreadSummary();
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      {text}
      {total ? <Badge count={total} size="small" overflowCount={99} /> : null}
    </span>
  );
};

// The group's icon carries the count: the label has no room beside the
// expand arrow, and the icon is all that shows when the sider is collapsed.
const UnreadIcon = ({ className }) => {
  const { total } = useUnreadSummary();
  return (
    <Badge count={total} size="small" overflowCount={99} offset={[2, -2]} className={className}>
      <MessageOutlined style={{ color: "inherit", fontSize: "inherit" }} />
    </Badge>
  );
};
const { Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

function checkAllowedPermissions(allowedPermissions, userPermissions) {
  let flag = false;
  if (allowedPermissions.length == 0) {
    return flag;
  } else {
    for (let i in allowedPermissions) {
      if (userPermissions?.find?.((item) => item == allowedPermissions[i])) {
        flag = true;
        break;
      }
    }
    return flag;
  }
}

const all_items = [
  // 1. Dashboard
  {
    key: 1,
    label: "Dashboard",
    icon: <PieChartOutlined />,
    allowedPermissions: ["dashboard:view"],
    route: "/",
  },
  // 2. Reports
  {
    key: "reports",
    label: "Reports",
    icon: <FiBarChart />,
    allowedPermissions: ["reports:view"],
    route: null,
    children: [
      {
        key: "reports-all",
        label: "All Reports",
        allowedPermissions: ["reports:view"],
        route: "/reports/all",
      },
      {
        key: "reports-sales",
        label: "Sales Report",
        allowedPermissions: ["reports:view"],
        route: "/reports",
      },
      {
        key: "reports-lead-conversion",
        label: "Lead Conversion",
        allowedPermissions: ["reports:view"],
        route: "/reports/lead-conversion",
      },
      {
        key: "reports-sales-pipeline",
        label: "Sales Pipeline",
        allowedPermissions: ["reports:view"],
        route: "/reports/sales-pipeline",
      },
      {
        key: "reports-receivables",
        label: "Accounts Receivable",
        allowedPermissions: ["reports:view"],
        route: "/reports/receivables",
      },
      {
        key: "reports-customer-revenue",
        label: "Customer Revenue",
        allowedPermissions: ["reports:view"],
        route: "/reports/customer-revenue",
      },
      {
        key: "reports-expenses",
        label: "Expense Report",
        allowedPermissions: ["reports:view"],
        route: "/reports/expenses",
      },
      {
        key: "reports-profit-loss",
        label: "Profit & Loss",
        allowedPermissions: ["reports:view"],
        route: "/reports/profit-loss",
      },
      {
        key: "reports-daily-operations",
        label: "Daily Operations",
        allowedPermissions: ["reports:view"],
        route: "/reports/daily-operations",
      },
      {
        key: "reports-monthly-sales",
        label: "Monthly Sales",
        allowedPermissions: ["reports:view"],
        route: "/reports/monthly-sales",
      },
      {
        key: "reports-employee-performance",
        label: "Employee Performance",
        allowedPermissions: ["reports:view"],
        route: "/reports/employee-performance",
      },
    ],
  },
  // 3. Contacts
  {
    key: 10,
    label: "Contacts",
    icon: <TeamOutlined />,
    allowedPermissions: ["contacts:view"],
    route: "/contacts",
  },
  // 4. Communication - the unified inbox, and the channel setup behind it
  {
    key: "communication",
    label: "Communication",
    icon: <UnreadIcon />,
    // Either permission is enough to see the group; the children below decide
    // which half of it a given role actually gets.
    allowedPermissions: ["communication:view", "templates:view"],
    route: null,
    children: [
      {
        key: "communication-dashboard",
        label: <UnreadLabel text="Dashboard" />,
        allowedPermissions: ["communication:view"],
        route: "/communication",
      },
      {
        key: "communication-configuration",
        label: "Configuration",
        allowedPermissions: ["templates:view"],
        route: "/communication/configuration",
      },
    ],
  },
  // 5. Sales
  {
    key: "sales",
    label: "Sales",
    icon: <FiDollarSign />,
    allowedPermissions: ["sales:view"],
    route: null,
    children: [
      {
        key: "sales-accounts",
        label: "Accounts",
        allowedPermissions: ["accounts:view"],
        route: "/accounts",
      },
      {
        key: "sales-leads",
        label: "Leads",
        allowedPermissions: ["leads:view"],
        route: "/leads",
      },
      {
        key: "sales-quotes",
        label: "Quotes",
        allowedPermissions: ["quotes:view"],
        route: "/quotes",
      },
      {
        key: "sales-deals",
        label: "Deals",
        allowedPermissions: ["deals:view"],
        route: "/deals",
      },
      {
        key: "sales-invoices",
        label: "Invoices",
        allowedPermissions: ["invoices:view"],
        route: "/invoices",
      },
      {
        key: "sales-payments",
        label: "Payments",
        allowedPermissions: ["payments:view"],
        route: "/payments",
      },
      {
        key: "sales-payment-links",
        label: "Payment Links",
        allowedPermissions: ["payments:view"],
        route: "/payment-links",
      },
      {
        key: "sales-credit-notes",
        label: "Credit Notes",
        allowedPermissions: ["credit_notes:view"],
        route: "/credit-notes",
      },
      {
        key: "sales-debit-notes",
        label: "Debit Notes",
        allowedPermissions: ["debit_notes:view"],
        route: "/debit-notes",
      },
    ],
  },
  // 5. Marketing
  {
    key: "marketing",
    label: "Marketing",
    icon: <MdCampaign />,
    allowedPermissions: ["marketing:view"],
    route: null,
    children: [
      {
        key: "marketing-campaigns",
        label: "Campaigns",
        allowedPermissions: ["campaigns:view"],
        route: "/campaigns",
      },
    ],
  },
  // 6. Accounting
  {
    key: "accounting",
    label: "Accounting",
    icon: <AiOutlineBank />,
    allowedPermissions: ["accounting:view", "expenses:view"],
    route: null,
    children: [
      {
        key: "accounting-bank-statements",
        label: "Bank Statements",
        allowedPermissions: ["accounting:view"],
        route: "/accounting/bank-statements",
      },
      {
        key: "accounting-bank-statements-view",
        label: "Bank Statements (View)",
        allowedPermissions: ["accounting:view"],
        route: "/accounting/bank-statements-view",
      },
      {
        key: "accounting-transactions-view",
        label: "Transactions (View)",
        allowedPermissions: ["accounting:view"],
        route: "/accounting/transactions-view",
      },
      {
        key: "accounting-expenses",
        label: "Expenses",
        allowedPermissions: ["expenses:view"],
        route: "/expenses",
      },
      {
        key: "accounting-budgets",
        label: "Budgets",
        allowedPermissions: ["accounting:view", "expenses:view"],
        route: "/accounting/budgets",
      },
      {
        key: "accounting-expense-categories",
        label: "Expense Categories",
        allowedPermissions: ["expenses:view"],
        route: "/expenses/categories",
      },
    ],
  },
  // 7. Project Board
  {
    key: "project_board",
    label: "Project Board",
    icon: <ProjectOutlined />,
    allowedPermissions: ["projects:view"],
    route: null,
    children: [
      {
        key: "project-overview",
        label: "Overview",
        allowedPermissions: ["projects:view"],
        route: "/projects/overview",
      },
      {
        key: "project-projects",
        label: "Projects",
        allowedPermissions: ["projects:view"],
        route: "/projects",
      },
      {
        key: "project-tasks",
        label: "Tasks",
        allowedPermissions: ["tasks:view"],
        route: "/tasks",
      },
    ],
  },
  // 8. Support
  {
    key: "support",
    label: "Support",
    icon: <BiSupport />,
    allowedPermissions: ["support:view"],
    route: null,
    children: [
      {
        key: "support-tickets",
        label: "Tickets",
        allowedPermissions: ["support:view"],
        route: "/support/tickets",
      },
      {
        key: "support-approvals",
        label: "Account Approvals",
        allowedPermissions: ["support:approve_accounts"],
        route: "/support/approvals",
      },
      {
        key: "support-analytics",
        label: "Analytics & Reports",
        allowedPermissions: ["support:view"],
        route: "/support/analytics",
      },
      {
        key: "support-knowledge-base",
        label: "Knowledge Base",
        allowedPermissions: ["support:view"],
        route: "/support/knowledge-base",
      },
      {
        key: "support-settings",
        label: "Settings",
        allowedPermissions: ["support:manage"],
        route: "/support/settings",
      },
    ],
  },
  // 9. HR
  {
    key: "hr",
    label: "HR",
    icon: <RiTeamLine />,
    allowedPermissions: ["hr:view"],
    route: null,
    children: [
      {
        key: "hr-performance-reviews",
        label: "Performance Reviews",
        allowedPermissions: ["hr:performance_reviews"],
        route: "/hr/performance-reviews",
      },
    ],
  },
  // 10. Timesheet
  {
    key: "timesheet",
    label: "Timesheet",
    icon: <FiClock />,
    allowedPermissions: ["timesheet:view"],
    route: null,
    children: [
      {
        key: "timesheet-attendance",
        label: "Attendance",
        allowedPermissions: ["attendance:view"],
        route: "/attendance",
      },
      {
        key: "timesheet-attendance-manager",
        label: "Attendance Manager",
        allowedPermissions: ["attendance:manage"],
        route: "/timesheet/attendance-manager",
      },
      {
        key: "timesheet-leave",
        label: "Leave Management",
        allowedPermissions: ["leaves_management:view"],
        route: "/leave-management",
      },
      {
        key: "timesheet-wfh",
        label: "Work From Home",
        allowedPermissions: ["work_from_home:view"],
        route: "/work-from-home",
      },
      {
        key: "timesheet-import",
        label: "Import Attendance",
        allowedPermissions: ["attendance:import"],
        route: "/timesheet/import-attendance",
      },
      {
        key: "timesheet-machine-logs",
        label: "Machine Logs",
        allowedPermissions: ["machine_logs:view"],
        route: "/timesheet/machine-logs",
      },
    ],
  },
  // 11. Payroll
  {
    key: "payroll",
    label: "Payroll",
    icon: <FiDollarSign />,
    allowedPermissions: ["payroll:view"],
    route: null,
    children: [
      {
        key: "payroll-run",
        label: "Run Payroll",
        allowedPermissions: ["payroll:run"],
        route: "/payroll/run",
      },
      {
        key: "payroll-history",
        label: "Payroll History",
        allowedPermissions: ["payroll:history"],
        route: "/payroll/history",
      },
    ],
  },
  // 12. Contracts
  {
    key: "contract",
    label: "Contracts",
    icon: <ProjectOutlined />,
    allowedPermissions: ["contracts:view"],
    route: null,
    children: [
      {
        key: "manage-contract",
        label: "Manage Contract",
        allowedPermissions: ["contracts:view"],
        route: "/contract",
      },
      {
        key: "contract-type",
        label: "Contract Type",
        allowedPermissions: ["contracts:view"],
        route: "/contract-type",
      }
    ],
  },
  // 13. Reminders
  {
    key: "reminders",
    label: "Reminders",
    icon: <FiBell />,
    allowedPermissions: ["reminders:view"],
    route: null,
    children: [
      {
        key: "reminders-rules",
        label: "Reminder Rules",
        allowedPermissions: ["reminders:view"],
        route: "/reminders/rules",
      },
      {
        key: "reminders-logs",
        label: "Reminder Logs",
        allowedPermissions: ["reminders:view"],
        route: "/reminders/logs",
      },
      {
        key: "reminders-whatsapp-templates",
        label: "WhatsApp Templates",
        allowedPermissions: ["reminders:view"],
        route: "/reminders/whatsapp-templates",
      },
      {
        key: "reminders-preferences",
        label: "Preferences",
        allowedPermissions: ["reminders:view"],
        route: "/reminders/preferences",
      },
    ],
  },
  // 14. Links
  {
    key: "links",
    label: "Links",
    icon: <LinkOutlined />,
    allowedPermissions: ["links:view"],
    route: null,
    children: [
      {
        key: "links-all",
        label: "All Links",
        allowedPermissions: ["links:view"],
        route: "/links",
      },
      {
        key: "links-categories",
        label: "Categories",
        allowedPermissions: ["links:view"],
        route: "/links/categories",
      },
    ],
  },
  // 15. Manage (includes Products)
  {
    key: "manage",
    label: "Manage",
    icon: <FiSettings />,
    allowedPermissions: ["manage:view"],
    route: null,
    children: [
      {
        key: "manage-products",
        label: "Products",
        allowedPermissions: ["products:view"],
        route: "/products",
      },
      {
        key: "manage-employees",
        label: "Employees",
        allowedPermissions: ["employees:view"],
        route: "/employees",
      },
      {
        key: "manage-users",
        label: "Users",
        allowedPermissions: ["users:view"],
        route: "/users",
      },
      {
        key: "manage-assets",
        label: "Assets",
        allowedPermissions: ["assets:view"],
        route: "/assets",
      },
      {
        key: "manage-assetfiles",
        label: "AssetFiles",
        allowedPermissions: ["assetfiles:view"],
        route: "/assetfiles",
      },
      {
        key: "manage-documents",
        label: "Documents",
        allowedPermissions: ["documents:view"],
        route: "/documents",
      },
      {
        key: "manage-templates",
        label: "Templates",
        allowedPermissions: ["templates:view"],
        route: "/templates",
      },
      {
        key: "manage-vendors",
        label: "Vendors",
        allowedPermissions: ["vendors:view"],
        route: "/vendors",
      },
      {
        key: "manage-emails",
        label: "Email Broadcast",
        icon: <MailOutlined />,
        allowedPermissions: ["emails:view"],
        route: "/emails",
      },
      {
        key: "manage-events",
        label: "Events & Meetings",
        allowedPermissions: ["events:view"],
        route: "/events",
      },
      {
        key: "manage-settings",
        label: "Settings",
        allowedPermissions: ["settings:view"],
        route: "/settings",
      },
    ],
  },
  // 16. Billing
  {
    key: "billing",
    label: "Billing",
    icon: <FaRupeeSign />,
    allowedPermissions: ["subscriptions:view"],
    route: null,
    children: [
      {
        key: "billing-subscriptions",
        label: "Subscriptions",
        allowedPermissions: ["subscriptions:view"],
        route: "/billing/subscriptions",
      },
      {
        key: "billing-plans",
        label: "Plan",
        allowedPermissions: ["subscriptions:view"],
        route: "/billing/plans",
      },
      {
        key: "billing-gateway",
        label: "Gateway",
        allowedPermissions: ["subscriptions:view"],
        route: "/billing/gateway",
      },
    ],
  },
  // 17. Tenant Management
  {
    key: "tenant-management",
    label: "Tenant Mgmt",
    icon: <CloudServerOutlined />,
    allowedPermissions: ["tenant_management:view"],
    route: null,
    children: [
      {
        key: "tm-saas-products",
        label: "SaaS Products",
        allowedPermissions: ["tenant_management:view"],
        route: "/tenant-management/saas-products",
      },
      {
        key: "tm-tenants",
        label: "Tenants",
        allowedPermissions: ["tenant_management:view"],
        route: "/tenant-management/tenants",
      },
      {
        key: "tm-subscriptions",
        label: "Subscriptions",
        allowedPermissions: ["tenant_management:view"],
        route: "/tenant-management/subscriptions",
      },
    ],
  },
  // 17. My Profile
  {
    key: 25,
    label: "My Profile",
    icon: <FiUser />,
    allowedPermissions: ["myprofile:view"],
    route: "/myprofile",
  },
  // 16. Logout
  {
    key: "logout",
    label: "Logout",
    icon: <LogoutOutlined />,
    allowedPermissions: ["myprofile:view"],
    route: null,
  },
];

// const items = [
//   getItem('Dashboard', '1', <PieChartOutlined />),
//   getItem('Accounts', '2', <RiTeamLine />),
//   getItem('Vendors', '3', <UserAddOutlined />),
//   getItem('Payments', '4', <FaRupeeSign />),
//   getItem('Invoices', '5', <TbFileInvoice />),
//   getItem('Quotes', '6', <TbFileInvoice />),
//   getItem('Expenses', '7', <GiExpense />),
//   getItem('Products', '8', <CgProductHunt />),
//   getItem('Services', '9', <MdMiscellaneousServices />),
//   getItem('Employees', '10', <TeamOutlined />),
//   getItem('Contacts', '11', <TeamOutlined />),
//   getItem('Users', '12', <UserOutlined />),
//   getItem('Settings', '13', <FiSettings />),
//   getItem('Documents', '14', <FiUploadCloud />),
//   getItem('Templates', '15', <TbFileInvoice />),
//   getItem('AssetFiles', '16', <FiUploadCloud />),
//   getItem('System Monitoring', '17', <MdOutlineMonitorHeart />),
//   getItem('Sales', '18', <MdOutlineMonitorHeart />),
//   getItem('Leads', '19', <MdOutlineMonitorHeart />)
// ];
// const newItems = items.map(item => {
//   return (
//     <AccessControlHidden userPermissions={user.user_permissions} allowedPermis>
//       {item}
//     </AccessControlHidden>
//   )
// })

// const routes = [
//   '/',
//   '/accounts',
//   '/vendors',
//   '/payments',
//   '/invoices',
//   '/quotes',
//   '/expenses',
//   '/products',
//   '/services',
//   '/employees',
//   '/contacts',
//   '/users',
//   '/settings',
//   '/documents',
//   '/template',
//   '/assetfiles',
//   '/systemmonitoring',
//   '/sales',
//   '/leads',
//   '/whatsapp'
// ];

//   getItem('User', 'sub1', <UserOutlined />, [
//     getItem('Tom', '3'),
//     getItem('Bill', '4'),
//     getItem('Alex', '5'),
//   ]),
//   getItem('Team', 'sub2', <TeamOutlined />, [getItem('Team 1', '6'), getItem('Team 2', '8')]),

// Helper function to find matching menu item based on current path
const findMatchingMenuItem = (pathname) => {
  let matchedItem = null;
  let parentKey = null;

  // First try exact match
  all_items.forEach((item) => {
    if (item.children) {
      const child = item.children.find((c) => c.route === pathname);
      if (child) {
        matchedItem = child;
        parentKey = item.key;
      }
    } else if (item.route === pathname) {
      matchedItem = item;
    }
  });

  // If no exact match, try prefix match (for routes like /leads/edit/123)
  if (!matchedItem) {
    all_items.forEach((item) => {
      if (item.children) {
        const child = item.children.find((c) => {
          if (!c.route) return false;
          // Check if pathname starts with the route
          return pathname.startsWith(c.route + "/") || pathname === c.route;
        });
        if (child) {
          matchedItem = child;
          parentKey = item.key;
        }
      } else if (item.route) {
        if (pathname.startsWith(item.route + "/") || pathname === item.route) {
          matchedItem = item;
        }
      }
    });
  }

  // Final fallback - match by first path segment
  if (!matchedItem) {
    const params = pathname.split("/").filter((x) => x.trim() !== "");
    const firstSegment = params.length > 0 ? params[0] : "";

    all_items.forEach((item) => {
      if (item.children) {
        const child = item.children.find((c) => {
          if (!c.route) return false;
          const routeSegment = c.route
            .split("/")
            .filter((x) => x.trim() !== "")[0];
          return routeSegment === firstSegment;
        });
        if (child) {
          matchedItem = child;
          parentKey = item.key;
        }
      } else if (item.route) {
        const routeSegment = item.route
          .split("/")
          .filter((x) => x.trim() !== "")[0];
        if (routeSegment === firstSegment) {
          matchedItem = item;
        }
      }
    });
  }

  return { matchedItem, parentKey };
};

const NavSider = ({ mobileOpen = false, onMobileClose = () => {} }) => {
  const [collapsed, setCollapsed] = useState(false);
  // The Sider collapses to zero width at `lg`; below that the nav lives in a drawer.
  const isMobile = useIsMobile(991);
  const [currentRoute, setCurrentRoute] = useState(null);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const { matchedItem, parentKey } = findMatchingMenuItem(location.pathname);

    if (matchedItem) {
      setCurrentRoute(matchedItem.key);
      // Open the parent submenu if this is a child item
      if (parentKey) {
        setOpenKeys((prev) => {
          if (!prev.includes(String(parentKey))) {
            return [...prev, String(parentKey)];
          }
          return prev;
        });
      }
    } else if (location.pathname === "/") {
      // Dashboard
      setCurrentRoute(1);
    }
  }, [location]);

  const user = useSelector((state) => state.auth.user);

  const filtered_items = all_items.filter((item) =>
    item.key === "logout" || item.key === 25 || checkAllowedPermissions(item.allowedPermissions, user?.user_permissions)
  );

  // Build menu items with nested children
  const items = filtered_items
    .map((item) => {
      if (item.children) {
        // Build children items with permission filtering
        const filteredChildren = item.children.filter((child) =>
          checkAllowedPermissions(
            child.allowedPermissions,
            user?.user_permissions
          )
        );

        const childItems = filteredChildren.map((child) =>
          getItem(child.label, child.key, null)
        );

        // Only show parent if it has visible children
        return childItems.length > 0
          ? getItem(item.label, item.key, item.icon, childItems)
          : null;
      }

      return getItem(item.label, item.key, item.icon);
    })
    .filter((item) => item !== null);

  // Build route map for navigation (flattened structure)
  const buildRouteMap = (items) => {
    const routeMap = {};
    items.forEach((item) => {
      if (item.children) {
        item.children.forEach((child) => {
          routeMap[child.key] = child.route;
        });
      } else if (item.route) {
        routeMap[item.key] = item.route;
      }
    });
    return routeMap;
  };

  const routeMap = buildRouteMap(all_items);
  // console.log(routes)
  // console.log(filtered_items)

  // Handle submenu open/close
  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const menu = (
    <Menu
      theme="dark"
      selectedKeys={currentRoute ? [`${currentRoute}`] : []}
      openKeys={collapsed && !isMobile ? [] : openKeys}
      onOpenChange={onOpenChange}
      mode="inline"
      items={items}
      onClick={(e) => {
        // Handle logout separately
        if (e.key === "logout") {
          onMobileClose();
          dispatch(logout());
          navigate("/");
          return;
        }
        setCurrentRoute(e.key);
        const route = routeMap[e.key];
        if (route) {
          // Ctrl+click or Cmd+click opens in new tab
          if (e.domEvent?.ctrlKey || e.domEvent?.metaKey) {
            window.open(route, "_blank");
          } else {
            navigate(route);
            onMobileClose();
          }
        }
      }}
      style={{ padding: "auto", paddingBottom: "50px" }}
    />
  );

  // Phones and tablets: the nav is an overlay drawer opened from the header.
  if (isMobile) {
    return (
      <Drawer
        // rootClassName (not className) targets the drawer root in antd v5,
        // which is what the responsive width rules key off.
        rootClassName="app-nav-drawer"
        placement="left"
        open={mobileOpen}
        onClose={onMobileClose}
        width={260}
        closable={false}
        styles={{ body: { padding: 0, background: "#001529" } }}
      >
        <div
          className="custom-scroll-div"
          style={{ height: "100%", overflowY: "auto", background: "#001529" }}
        >
          <div className="logo" style={{ height: "50px" }}>
            <FcList size={20} style={{ margin: "16px 28px" }} />
          </div>
          {menu}
        </div>
      </Drawer>
    );
  }

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={(broken) => setCollapsed(broken)}
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div
        className="custom-scroll-div"
        style={{ height: "100vh", overflowY: "auto" }}
      >
        <div className="logo" style={{ height: "50px" }}>
          <FcList size={20} style={{ margin: "16px 28px" }} />
        </div>
        {menu}
      </div>
    </Sider>
  );
};
export default NavSider;
